import { Country } from './Country';
import { Region } from './Region';
import { DealStatusType } from 'components/common/StatusBadge/DealStatusBadge';

export interface Deal {
  id: string;
  uuid: string | number;
  key?: string;
  client: Record<string, any>;
  country: Country;
  region: Region;
  createDate: string;
  formattedCreateDate: string;
  lastModifiedDate: string;
  formattedLastModifiedDate: string;
  clientRequestNumber: string;
  status: DealStatusType;
  leadId?: string;
  rejectionReason?: string;
  rejectionAdditionalInformation?: string;
  isFinalStatus?: boolean;
  createdBy?: {
    firstName?: string;
    lastName?: string;
  };
  lastModifiedBy?: {
    firstName?: string;
    lastName?: string;
  };
  emailId?: string;
}

export const DealRejectionReasons = {
  OUT_OF_SCOPE: { label: 'Out of scope', value: 'OUT_OF_SCOPE' },
  DUPLICATE_DEAL: { label: 'Duplicate deal', value: 'DUPLICATE_DEAL' },
  CUSTOMER_NOT_RESPONSIVE: { label: 'Customer not responsive', value: 'CUSTOMER_NOT_RESPONSIVE' },
  NO_BRAND: { label: 'No Brand', value: 'NO_BRAND' },
  NO_LONGER_NEEDED: { label: 'No longer needed', value: 'NO_LONGER_NEEDED' },
  OTHER: { label: 'Other', value: 'OTHER' },
};
